import React from "react";
import { fileNameHelper } from "../amorg-common";
import { colors } from "./colors/color";
import { Icon } from "./icons/Icons";


type FileIconProps = {
    publicFileName: string
}
export function FileIcon(props:FileIconProps):JSX.Element
{
    function getExtensionIcon (filename: string): JSX.Element
    {
        const ext = fileNameHelper.getSupportedFileExtension(filename);

        if (ext === 'csv')
            return <Icon color="darkgray" name='file_csv' />;

        else if (ext === 'xls' || ext === 'xlsx')
            return <Icon color={colors.icon.default} name='file_excel' />;

        else if (ext === 'mov' || ext === 'mp4')
            return <Icon color={colors.icon.default} name='file_film' />;

        else if (ext === 'jpg' || ext === 'png' || ext === 'jpeg')
            return <Icon color={colors.icon.default} name='file_image' />;

        else if (ext === 'pdf')
            return <Icon color={colors.icon.default} name='file_pdf' />;

        else if (ext === 'txt' || ext === 'rtf')
            return <Icon color={colors.icon.default} name='file_text' />;

        else if (ext === 'doc' || ext === 'docx')
            return <Icon color={colors.icon.default} name='file_word' />;

        else
            return <Icon color={colors.icon.default} name='file' />;
    }

    return (
        <>{getExtensionIcon(props.publicFileName)}</>
    );
}